import { render, staticRenderFns } from "./SettingsInfo.vue?vue&type=template&id=9556e6ec&"
import script from "./SettingsInfo.vue?vue&type=script&lang=js&"
export * from "./SettingsInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingsInfo.vue?vue&type=style&index=0&id=9556e6ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports